/**
 *  @class
 *  @function FacetsToggle
 */
class FacetsToggle extends HTMLElement {
  constructor() {
    super();
    this.drawer = document.getElementById('Facet-Drawer');
  }
  connectedCallback() {
    this.addEventListener('click', () => {
      document.body.classList.toggle('open-cc');
      this.drawer.classList.toggle('active');
      this.drawer.removeAttribute('inert');
    });
  }
}
customElements.define('facet-toggle', FacetsToggle);

/**
 *  @class
 *  @function SidebarToggle
 */
class SidebarToggle extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const span = this.querySelector('span');
    const hideFilters = span.textContent;

    this.addEventListener('click', (e) => {
      e.preventDefault();
      this.drawer = document.getElementById('Sidebar-Container');
      this.drawer.classList.toggle('facets--sidebar-open');

      span.textContent = this.drawer.classList.contains('facets--sidebar-open') ? hideFilters : theme.strings.showFilters;
    });
  }
}
customElements.define('sidebar-toggle', SidebarToggle);

/**
 *  @class
 *  @function FacetFiltersForm
 */
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  connectedCallback() {
    // „Mehr anzeigen“ per Delegation: funktioniert auch für Buttons, die nach einem Filterklick neu gezeichnet wurden
    if (this.moreBound) return;
    this.moreBound = true;
    this.addEventListener('click', (e) => {
      const button = e.target.closest('.thb-filter-content--button');
      if (!button || !this.contains(button)) return;
      e.preventDefault();
      FacetFiltersForm.toggleMore(button);
    });
  }
  static toggleMore(button, open) {
    const ul = button.closest('.thb-filter-content').querySelector('ul');
    if (!ul) return;
    if (open === undefined) open = !ul.hasAttribute('filters-open');
    ul.toggleAttribute('filters-open', open);
    button.textContent = open ? theme.strings.showLess : theme.strings.showMore;
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.querySelectorAll('.thb-filter-count, .mobile-filter-count');
    // Bei 0 Treffern gibt es kein .products (nur .collection-empty) → ohne Prüfung brach hier alles ab
    // und „Alle entfernen“ bzw. die Filter-Chips taten nichts mehr.
    const grid = document.querySelector('#ProductGridContainer .products');
    if (grid) grid.classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        FacetFiltersForm.renderSection(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderSection(html, event);
  }

  // Filter, Produktliste und Trefferzahl neu zeichnen, ohne dass der Kunde seine Ansicht verliert:
  // offene/geschlossene Gruppen, „Mehr anzeigen“, Scroll-Position der Leiste und Fokus bleiben erhalten.
  // Alles läuft synchron in einem Schritt, damit der Browser keine Zwischenstände zeichnet.
  static renderSection(html, event) {
    const state = FacetFiltersForm.captureState();
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    // Eigene Anpassungen (cb-facets.js, Standort-Labels usw.) sofort anwenden statt zeitversetzt
    document.dispatchEvent(new CustomEvent('facets:updated'));
    FacetFiltersForm.restoreState(state);
  }

  static captureState() {
    const active = document.activeElement;
    return ['FacetFiltersFormMobile', 'FacetFiltersForm'].map((formId) => {
      const form = document.getElementById(formId);
      if (!form) return null;
      const rows = {};
      form.querySelectorAll('collapsible-row[data-index]').forEach((row) => {
        const details = row.querySelector('details');
        rows[row.dataset.index] = {
          open: details ? details.open : true,
          more: !!row.querySelector('ul[filters-open]')
        };
      });
      const scroller = form.closest('.side-panel-content') || form;
      return {
        formId,
        rows,
        scrollTop: scroller.scrollTop,
        focusId: active && active.id && form.contains(active) ? active.id : null
      };
    }).filter(Boolean);
  }

  static restoreState(states) {
    states.forEach((state) => {
      const form = document.getElementById(state.formId);
      if (!form) return;
      form.querySelectorAll('collapsible-row[data-index]').forEach((row) => {
        const saved = state.rows[row.dataset.index];
        if (!saved) return;
        const details = row.querySelector('details');
        if (details && details.open !== saved.open) details.open = saved.open;
        const button = row.querySelector('.thb-filter-content--button');
        if (saved.more && button && button.style.display !== 'none') FacetFiltersForm.toggleMore(button, true);
      });
      const scroller = form.closest('.side-panel-content') || form;
      scroller.scrollTop = state.scrollTop;
      if (state.focusId) {
        const focusTarget = form.querySelector(`[id="${CSS.escape(state.focusId)}"]`);
        if (focusTarget && focusTarget !== document.activeElement) focusTarget.focus({ preventScroll: true });
      }
    });
  }

  static renderProductGridContainer(html) {
    const source = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer');
    if (!source) return;
    document.getElementById('ProductGridContainer').innerHTML = source.innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    ScrollTrigger.batch('.animations-true .products .product-card--image-primary', {
      start: "top 90%",
      onEnter: (elements) => {
        gsap.to(elements, { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
      }
    });
    document.getElementById('ProductGridContainer').querySelectorAll('.lazyload').forEach((image) => {
      lazySizes.loader.unveil(image);
    });

    // Nur hochscrollen, wenn der Anfang der Produktliste über dem sichtbaren Bereich liegt
    // (vorher sprang die Seite nach jedem Filterklick, auch wenn man schon oben war).
    if (top < document.documentElement.scrollTop) {
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: reduceMotion ? "auto" : "smooth"
      });
    }
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    // Nur die Zählerzeile über der Produktliste; die Zahl im Handy-Filterfenster setzt renderAdditionalElements
    const container = document.querySelectorAll('.thb-filter-count:not(.mobile-filter-count)');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // Hier nur die Handy-Leiste aktualisieren. Die Desktop-Leiste steckt in #ProductGridContainer
    // und wird mit der Produktliste neu gezeichnet. (Vorher landete das Desktop-HTML in der Handy-Leiste.)
    // Pro Gruppe wird nur der Inhalt ersetzt; <details>/<summary> bleiben stehen, offen/zu ändert sich nicht.
    const form = document.getElementById('FacetFiltersFormMobile');
    const eventRow = event && event.target && event.target.closest ? event.target.closest('collapsible-row') : null;
    if (form) {
      parsedHTML.querySelectorAll('#FacetFiltersFormMobile collapsible-row[data-index]').forEach((source) => {
        const target = form.querySelector(`collapsible-row[data-index="${source.dataset.index}"]`);
        if (!target) return;
        // Preisregler, an dem der Kunde gerade zieht oder tippt, nicht austauschen
        if (target === eventRow && target.querySelector('price-slider')) return;
        const sourceContent = source.querySelector('.collapsible__content');
        const targetContent = target.querySelector('.collapsible__content');
        if (sourceContent && targetContent) {
          targetContent.className = sourceContent.className;
          targetContent.innerHTML = sourceContent.innerHTML;
        } else {
          target.innerHTML = source.innerHTML;
        }
        // cb-facets.js soll die frisch gezeichnete Gruppe neu aufbereiten
        target.removeAttribute('data-cbf-done');
      });
    }

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const target = document.querySelector(selector);
      if (!activeFacetsElement || !target) return;
      target.innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      const target = document.querySelector(selector);
      if (!html.querySelector(selector) || !target) return;
      target.innerHTML = html.querySelector(selector).innerHTML;
      target.classList.remove('loading');
    });
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    // #product-grid trägt die Section-ID; Rückfall: die umschließende Shopify-Section
    const grid = document.getElementById('product-grid');
    const wrapper = document.getElementById('ProductGridContainer')?.closest('.shopify-section');
    return [
      {
        section: grid ? grid.dataset.id : (wrapper ? wrapper.id.replace('shopify-section-', '') : ''),
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const searchParams = new URLSearchParams(formData);
    // Desktop: Sortierung (Leiste oben) und Filter (Sidebar) sind getrennte Formulare und schicken nur ihre
    // eigenen Felder. Den Rest aus dem aktuellen Stand übernehmen, sonst verliert Sortieren die Filter und
    // ein Filterklick die Sortierung. Die versteckten Filterfelder der Leiste stammen vom Seitenaufruf und sind veraltet.
    const current = new URLSearchParams(FacetFiltersForm.searchParamsPrev);
    if (form.classList.contains('facets--bar-right')) {
      [...searchParams.keys()].forEach((key) => {
        if (key.startsWith('filter.')) searchParams.delete(key);
      });
      current.forEach((value, key) => {
        if (key.startsWith('filter.')) searchParams.append(key, value);
      });
    } else {
      current.forEach((value, key) => {
        if (key === 'page' || key.startsWith('filter.') || searchParams.has(key)) return;
        searchParams.append(key, value);
      });
    }
    // Leere Von/Bis-Felder (Zahlen-Filter) nicht als „…lte=“ in die URL schreiben
    [...searchParams.keys()].forEach((key) => {
      if (key.startsWith('filter.') && searchParams.get(key) === '') searchParams.delete(key);
    });
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

/**
 *  @class
 *  @function FacetRemove
 */
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function FacetToolbar
 */
class FacetToolbar extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.productGrid = this.closest('#ProductGridContainer');
    this.compareToggle = this.querySelector('#compare_toggle');
    this.layoutSwitcher = this.querySelector('.facets--bar-view-as');
    this.buttons = this.querySelectorAll('.facets--bar-view-as-button');
    this.productLayout = window.localStorage.getItem('product-layout');
    if (this.layoutSwitcher) {
      this.buttons.forEach((button) => {
        button.addEventListener('click', (evt) => {
          [].forEach.call(this.buttons, function (el) {
            el.removeAttribute('disabled');
          });
          this.onLayoutChange(button, button.dataset.value);
          evt.preventDefault();
        });
      });

      if (this.productLayout && this.productLayout === 'list') {
        const toggle = this.querySelector(`.facets--bar-view-as-button-${this.productLayout}`);
        if (toggle) toggle.click();
      }
    }
    if (this.compareToggle) {
      this.compareToggle.addEventListener('change', this.onCompare);
    }
  }
  onLayoutChange(button, value) {
    button.setAttribute('disabled', '');
    this.productGrid.dataset.layout = value;
    window.localStorage.setItem('product-layout', value);
  }
  onCompare(e) {
    document.body.classList.toggle('compare-true');
    e.preventDefault();
  }
}
customElements.define('facet-toolbar', FacetToolbar);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    this.slider = this.querySelector('.price_slider');
    this.amounts = this.querySelector('.price_slider_amount');
    this.form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    this.inputEvent = new CustomEvent('input');

    const args = {
      start: [
        parseFloat(this.slider.dataset.minValue || 0),
        parseFloat(this.slider.dataset.maxValue || this.slider.dataset.max)
      ],
      connect: true,
      step: 10,
      direction: document.dir,
      handleAttributes: [
        { 'aria-label': 'lower' },
        { 'aria-label': 'upper' },
      ],
      range: {
        'min': 0,
        'max': parseFloat(this.slider.dataset.max)
      }
    };
    noUiSlider.create(this.slider, args);

    this.slider.noUiSlider.on('update', this.onSliderUpdate.bind(this));
    this.slider.noUiSlider.on('change', this.onSliderChange.bind(this));
  }
  onSliderUpdate(values) {
    this.amounts.querySelector('.field__input_min').value = values[0];
    this.amounts.querySelector('.field__input_max').value = values[1];
  }

  onSliderChange(values) {
    this.form.querySelector('form').dispatchEvent(this.inputEvent);
  }
}
customElements.define('price-slider', PriceSlider);

/* Sortieroptionen (Ausblenden, „Neueste zuerst“) kommen jetzt direkt aus snippets/cb-sort-options.liquid. */

/* StickyScroller für Filter-Sidebar deaktivieren — reines CSS-Scroll */
(function() {
  const sidebar = document.querySelector('.facets-desktop-container sticky-scroller');
  if (sidebar) {
    const el = sidebar.querySelector('.sticky-scroller--element');
    if (el) {
      el.classList.remove('sticky-scroller--element');
      el.style.overflowY = 'auto';
    }
  }
})();

/* Desktop-Filterleiste: Höhe an den sichtbaren Bereich anpassen. Oben auf der Seite ragte die Leiste
   sonst unten aus dem Bildschirm, und man musste erst die Seite scrollen, um ans Ende der Filter zu kommen. */
(function() {
  let ticking = false;
  function fitSidebar() {
    ticking = false;
    const form = document.querySelector('.facets-desktop-container .facets__form');
    if (!form || !form.offsetParent) return;
    const top = Math.max(form.getBoundingClientRect().top, 0);
    form.style.maxHeight = Math.max(window.innerHeight - top, 200) + 'px';
  }
  function requestFit() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(fitSidebar);
  }
  window.addEventListener('scroll', requestFit, { passive: true });
  window.addEventListener('resize', requestFit);
  document.addEventListener('facets:updated', fitSidebar);
  fitSidebar();
})();

/* ══════════════════════════════════════════════════════════════
   CB CUSTOM: Standort-Labels umbenennen
   "Köln" → "Köln (E-Bikes)" / "Köln (Bio-Bikes)"
   ══════════════════════════════════════════════════════════════ */
(function() {
  var STANDORT_LABEL_MAP = {
    'Store Köln (E-Bikes)':    'Köln (E-Bikes)',
    'Store Köln (Bio-Bikes)':  'Köln (Bio-Bikes)'
  };

  function rewriteStandortLabels() {
    var checkboxes = document.querySelectorAll('input[name="filter.p.m.global.standort"]');
    checkboxes.forEach(function(cb) {
      var newLabel = STANDORT_LABEL_MAP[cb.value];
      if (!newLabel) return;

      var li = cb.closest('li');
      if (!li) return;

      var textEl = li.querySelector('.thb-filter-text');
      if (textEl && textEl.textContent.trim() !== newLabel) {
        textEl.textContent = newLabel;
      }

      /* Tooltip mit aktualisieren (für Hover-Konsistenz) */
      var label = li.querySelector('label');
      if (label && label.hasAttribute('data-tooltip')) {
        var count = li.querySelector('.count');
        var countTxt = count ? ' (' + count.textContent.trim() + ')' : '';
        label.setAttribute('data-tooltip', newLabel + countTxt);
      }
    });
  }

  /* Initial + nach jedem AJAX-Update */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rewriteStandortLabels);
  } else {
    rewriteStandortLabels();
  }
  document.addEventListener('facets:updated', rewriteStandortLabels);

  var target = document.getElementById('ProductGridContainer');
  if (target) {
    new MutationObserver(function() {
      setTimeout(rewriteStandortLabels, 50);
    }).observe(target, { childList: true, subtree: true });
  }
})();

/* ══════════════════════════════════════════════════════════════
   CB CUSTOM: Standort "Transporter" aus Filtern entfernen
   ══════════════════════════════════════════════════════════════ */
(function() {
  // Projektregel: alles, was mit „Transporter“ beginnt (Transporter, Transporter2 …)
  function hideTransporterStandort() {
    var checkboxes = document.querySelectorAll('input[name="filter.p.m.global.standort"]');
    checkboxes.forEach(function(cb) {
      if (!/^\s*transporter/i.test(cb.value)) return;

      var li = cb.closest('li');
      if (li) li.style.display = 'none';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideTransporterStandort);
  } else {
    hideTransporterStandort();
  }
  document.addEventListener('facets:updated', hideTransporterStandort);

  var target = document.getElementById('ProductGridContainer');
  if (target) {
    new MutationObserver(function() {
      setTimeout(hideTransporterStandort, 50);
    }).observe(target, { childList: true, subtree: true });
  }
})();